import { Collection } from "@type-r/models";
import { asTimelessDate, Column, Columns, Flex } from "lqx-react";
import React from "react";
import { CustomerReferenceDataChange } from "../../api/customerReferenceData";
import { AssetTileField, AssetTileHeaderField, AssetTileStatusField, CheckboxColumn, EventsColumn, FirstColumn, SecondColumn, TileContainer, useAssetTileClasses } from "../../components/asset-section-styles";
import { DigiCheckbox, DigiTooltip, limitText } from "../../shared";
import { InblockedAssetsEventStatus } from "../inblocked-assets-event-status";
import { CustomerReferenceDataExternalSystems } from "./externalSystems";

export const CustomerReferenceDataTile = ($active, selected: Collection<CustomerReferenceDataChange>, selectAllAssets) => (({ data, index, style }) => {
    const crd: CustomerReferenceDataChange = data.items[index];
    const classes = useAssetTileClasses({ isSelected: $active.value && $active.value.id === crd.id });
    const $checked = selected ? selected.$includes(crd) : null;
    const applyNumbersFormat = (num) => parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    const onUnappliedCashClicked = crd => $active.set(crd);

    return (<>
        <div key={crd.id} style={style} className={classes.root} onClick={() => onUnappliedCashClicked(crd)}>
            <TileContainer>
                {selectAllAssets.value &&
                    <CheckboxColumn>
                        <DigiCheckbox checked={true} disabled={true} />
                    </CheckboxColumn>
                }
                {$checked && !selectAllAssets.value &&
                    <CheckboxColumn>
                        <DigiCheckbox $checked={$checked} disabled={selectAllAssets.value} />
                    </CheckboxColumn>
                }
                <Column>
                    <Flex row>
                        <Columns>
                            <EventsColumn>
                                <Flex row>
                                    <InblockedAssetsEventStatus assetChange={crd} externalSystems={CustomerReferenceDataExternalSystems} />
                                </Flex>
                                <Flex row>
                                    {/* <>DummyCell</> */}
                                </Flex>
                            </EventsColumn>
                            <FirstColumn>
                                <Flex row>
                                    <DigiTooltip title={crd.customerNumber}>
                                        <AssetTileStatusField>{limitText(crd.customerNumber, 20)}</AssetTileStatusField>
                                    </DigiTooltip>
                                </Flex>
                                <Flex row>
                                    <AssetTileField>Effective Date {asTimelessDate(crd.effectiveDate)}</AssetTileField>
                                </Flex>
                            </FirstColumn>
                            <SecondColumn>
                                <Flex row>
                                    <DigiTooltip title={`${crd.customerName}`}>
                                        <AssetTileHeaderField>{limitText(crd.customerName, 60)}</AssetTileHeaderField>
                                    </DigiTooltip>
                                </Flex>
                                <Flex row>
                                    <AssetTileField>Country Code {crd.countryCode} </AssetTileField>
                                </Flex>
                            </SecondColumn>
                        </Columns>
                    </Flex>
                </Column>
            </TileContainer>
        </div >
    </>
    )
})
